<template>
    <GuestLayout>

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <form @submit.prevent="submit">
            <div class="field">
                <label for="email">Email</label>
                <InputText id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
                <div v-if="form.errors.email" class="text-red-600">{{ form.errors.email }}</div>
            </div>

            <div class="field mt-4">
                <label for="password">Password</label>
                <InputText id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autofocus autocomplete="current-password" />
                <div v-if="form.errors.password" class="text-red-600">{{ form.errors.password }}</div>
            </div>

            <div class="field-checkbox mt-4">
                <Checkbox id="remember" v-model="form.remember" :binary="true" />
                <label for="remember">Remember me</label>
            </div>

            <div class="flex flex-row align-items-center justify-content-end mt-4">

<!--                <Link v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">-->
<!--                    Forgot your password?-->
<!--                </Link>-->


                    <Button :disabled="form.processing" type="submit">
                        Log in
                    </Button>


            </div>
        </form>
    </GuestLayout>
</template>

<script>
    import GuestLayout from '@/Layouts/Guest.vue';
    import InputText from "primevue/inputtext"
    import Button from "primevue/button"
    import Checkbox from "primevue/checkbox"

    export default {
        metaInfo(){
            return {
                "title": "Log in"
            }
        },
        props:{
            canResetPassword: Boolean,
            status: String
        },
        components:{
            InputText, Button, GuestLayout, Checkbox
        },
        data(){
            return {
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: false
                }),
            }
        },
        methods: {
            submit(){
                this.form.post(route('login'), {
                    onSuccess: () => this.form.reset('password'),
                });
            }
        }
    }
</script>
